<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div class="col-md-12">
      <div class="page-breadcrumb"><!-- new -->
        <ul class="page-breadcrumb__trail">
          <li><a>Manage</a></li>
          <li><a>User Setting</a></li>
          <li><a>Person Role</a></li>
        </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home"><img src="assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
        </div>
      </div>
      <div class="block">
        <div class="page-header"> <!--changed new-->
          <span class="page-header__title">Person Role</span>
          <img src="assets/images/New_Icons/refresh-icon.svg" alt="Refresh" title="Refresh" class="page-header__icon" width="17" height="17" (click)="!enableDisablePageLoader ? ngOnInit() : null"/>
        </div>
        <div class="list_block">
          <div class="toolbar"> <!--search and new changed new-->
            <div class="toolbar__search">
              <img src="../../../../../../assets/images/New_Icons/search-icon.svg">
              <input type="text" (ngModelChange)="onSearchChanged()" [(ngModel)]="search" name="search" autocomplete="off" placeholder="Search by person role name, code"/>
            </div>
            <div class="toolbar__spacer"></div>
            <div class="toolbar__add-button" (click)="openForm()">
              <button type="button">
                <span class="toolbar__add-icon">
                  <img src="../../../../../../assets/images/New_Icons/plus-icon.svg" alt="Add Icon"/>
                </span>
                <span class="toolbar__add-text">Add New</span>
              </button>
            </div>
          </div>
        </div>
        <!--person role block-->
        <div *ngIf="enableDisablePageLoader">
          <div class="adjust">
            <div class="loader2"></div>
          </div>
        </div>
        <div class="cards_container" *ngIf="!enableDisablePageLoader">
          <div class="card_wrapper" *ngFor="let role of personRoleList; let i = index">
            <div class="master-card">
              <div class="master-card-header">
                <div class="master-card-title">
                  <img src="../../../../../../assets/images/New_Icons/card-heading.svg">
                  <span>{{ role && role.name }}</span>
                </div>
              </div>
              <div class="master-card-body">
                <div class="master-card-body-info">
                  <img src="../../../../../../assets/images/New_Icons/calendar-icon.svg">
                  <span>Updated At: {{role && role.updatedAt | date: "dd MMM yyyy"}}</span>
                </div>
                <div class="master-card-body-info">
                  <img src="../../../../../../assets/images/New_Icons/descriptio-card-icon.svg">
                  <span
                    class="description">{{role && role.description ? role && role.description : 'NA'}}</span>
                </div>
              </div>
              <div class="master-card-footer">
                <div class="master-card-footer-info">
                  <span class="label">Code:</span>
                  <span class="text">{{ role?.code || "NA" }}</span>
                </div>
                <div class="action-icons">
                  <a>
                    <img src="../../../../../../assets/images/New_Icons/edit.svg" title="Edit Person Role" (click)="getPersonRoleById(role.id)">
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="listLoader" class="loader-div">
          <div class="adjust">
            <div class="loader2 list-loader"></div>
          </div>
        </div>
        <div *ngIf="noList && !enableDisablePageLoader" class="noDataFoundMessage">Person role Not Found</div>
        <!-- species type block end-->
      </div>
      <!--add/update form-->
      <div class="dynamic-form-wrapper" [ngClass]="{ 'floating-panel': formFieldCount <= 7, 'slide-in-overlay': formFieldCount > 7}" *ngIf="showForm">
        <!--<div *ngIf="formFieldCount > 7" class="overlay-background" (click)="closeForm()"></div>-->
        <!--outside close-->
        <div class="popup-wrapper">
          <button type="button" class="popup-close-beside" (click)="clear()" title="Close">&times;</button>
          <!-- Actual Popup -->
          <div [ngClass]="{ 'form-container-panel': formFieldCount > 7, 'popup-inner': formFieldCount <= 7}">
            <form [formGroup]="registerForm" novalidate>
              <div class="form-header">
                <div class="form-title">Person Role</div>
                <button class="add-update-submit-button" (click)="addPersonRole()" [disabled]="personRoleDoubleClick">
                  <span class="icon"><img src="../../../../../../assets/images/New_Icons/tick-icon.svg"></span>
                  <span class="text">{{ submitButton ? 'Submit' : 'Update' }}</span>
                </button>
              </div>
              <div class="form-container">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Name</mat-label>
                  <input matInput id="activityName" type="text" formControlName="name" autocomplete="off" placeholder="Enter name"/>
                  <!-- Hint -->
                  <mat-hint><i>3–20 alphabetic characters</i></mat-hint>
                  <!-- Single dynamic error -->
                  <mat-error *ngIf="(personRoleFormValidation.name.dirty || personRoleFormValidation.name.touched || submitted) && personRoleFormValidation.name.errors">
                    <i> {{personRoleFormValidation.name.hasError('required') ? 'Person role name is required.': personRoleFormValidation.name.hasError('minlength')? 'Minimum 3 characters required.': personRoleFormValidation.name.hasError('maxlength')
                      ? 'Maximum 20 characters allowed.' : personRoleFormValidation.name.hasError('pattern') ? 'Only alphabets allowed.': ''}}</i>
                  </mat-error>
                </mat-form-field>
                <!-- person role Name -->
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Code</mat-label>
                  <input matInput id="unitCode" type="text" autocomplete="off" formControlName="code" placeholder="Enter code"/>
                  <mat-hint><i>3–10 alphanumeric characters</i></mat-hint>
                  <mat-error *ngIf="(personRoleFormValidation.code.touched || personRoleFormValidation.code.dirty || submitted) && personRoleFormValidation.code.errors">
                    <i> {{personRoleFormValidation.code.hasError('minlength') ? 'Minimum 3 characters required.' : personRoleFormValidation.code.hasError('maxlength') ? 'Maximum 10 characters allowed.' : personRoleFormValidation.code.hasError('pattern') ? 'Special characters are not allowed.' : ''}}</i>
                  </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Select Business Types</mat-label>
                  <mat-select formControlName="businessType" multiple placeholder="Choose options">
                    <mat-option *ngFor="let option of businessTypes" [value]="option.id">{{ option.name }}</mat-option>
                  </mat-select>
                  <mat-hint><i>Choose one or more business types</i></mat-hint>
                  <mat-error *ngIf="(submitted || personRoleFormValidation.businessType.touched) && personRoleFormValidation.businessType.hasError('required')">
                    <i>At least one business type is required.</i>
                  </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Description</mat-label>
                  <textarea matInput id="activityDescription" rows="3" formControlName="description" autocomplete="off" placeholder="Description"></textarea>
                  <mat-hint><i>Up to 200 characters</i></mat-hint>
                  <mat-error *ngIf="(personRoleFormValidation.description.dirty || personRoleFormValidation.description.touched || submitted) && personRoleFormValidation.description.hasError('maxlength')">
                    <i>Maximum 200 characters allowed.</i>
                  </mat-error>
                </mat-form-field>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!--add/update form end-->
    </div>
  </div>
</div>
